import { StaffService } from './../../_services/staff.service';
import { PaginationInfo } from './../../_models/pagination-info';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CourseService } from '../../_services/course.service';

@Component({
  selector: 'iq-central-front-end-assign-course',
  templateUrl: './assign-course.component.html',
  styleUrls: ['./assign-course.component.scss'],
})
export class AssignCourseComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private _course: CourseService,
    private router: Router,
    private _staff: StaffService
  ) {
    this.isIndividualCheck = false;
    this.isDepartmentCheck = false;
    this.isDivisionCheck = false;
    this.isUnitCheck = false;
  }
  sub: Subscription = new Subscription();
  selectedIndividuals: any[] = [];

  selectedDepartments: any[] = [];
  filterDepartments: any;
  selectedDivisions: any[] = [];
  selectedUnits: any[] = [];

  lists: any[] = [];
  departments: any[] = [];
  divisions: any[] = [];
  units: any[] = [];
  paginationInfo: PaginationInfo;
  staffs: any[] = [];
  filterStaffs: any;
  isIndividualCheck: boolean;
  isDepartmentCheck: boolean;
  isDivisionCheck: boolean;
  isUnitCheck: boolean;
  ngOnInit(): void {
    this.getResolvedData();
    const code = this.route.snapshot.paramMap.get('code');
    if (code == null || code == '') {
      return;
    } else {
      this._course.setCourseData({ courseCodes: [code] });
    }
    this.getAssignmentData();
    this.lists = [1, 2, 3, 4, 5, 6, 7];
  }

  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.departments = this.filterDepartments =
          res['resolvedData'].departments['responseResult'];
        this.divisions = res['resolvedData'].divisions['responseResult'];
        this.units = res['resolvedData'].units['responseResult'];

        this.staffs = this.filterStaffs =
          res['resolvedData'].staffs['responseResult'].users;
        this.paginationInfo =
          res['resolvedData'].staffs['responseResult'].paginationInfo;

        // console.log(this.staffs);
      })
    );
  }
  getAssignmentData() {
    this._course.getCsDTOData().subscribe((res) => {});
  }

  selectDeselectIndividuals(staffId) {
    this.selectedIndividuals.includes(staffId)
      ? (this.selectedIndividuals = this.selectedIndividuals.filter(
          (sId) => sId != staffId
        ))
      : this.selectedIndividuals.push(staffId);
  }

  checkUncheckAll() {
    for (var i = 0; i < this.staffs.length; i++) {
      this.staffs[i].isSelected = this.isIndividualCheck;
    }
    this.getCheckedItemList();
  }

  isAllSelected() {
    this.isIndividualCheck = this.staffs.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.selectedIndividuals = [];
    for (let i = 0; i < this.staffs.length; i++) {
      if (this.staffs[i].isSelected)
        this.selectedIndividuals.push(this.staffs[i].id);
    }

    // this.selectedCourses = JSON.stringify(this.checkedCategoryList);
  }

  selectDeselectDepartments(departmentId) {
    this.selectedDepartments.includes(departmentId)
      ? (this.selectedDepartments = this.selectedDepartments.filter(
          (sId) => sId != departmentId
        ))
      : this.selectedDepartments.push(departmentId);
  }

  checkUncheckAllDept() {
    for (var i = 0; i < this.departments.length; i++) {
      this.departments[i].isSelected = this.isDepartmentCheck;
    }
    this.getCheckedDeptList();
  }

  isAllDeptSelected() {
    this.isDepartmentCheck = this.departments.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedDeptList();
  }

  getCheckedDeptList() {
    this.selectedDepartments = [];
    for (let i = 0; i < this.departments.length; i++) {
      if (this.departments[i].isSelected)
        this.selectedDepartments.push(this.departments[i].id);
    }
  }

  selectDeselectDivisions(divisionId) {
    this.selectedDivisions.includes(divisionId)
      ? (this.selectedDivisions = this.selectedDivisions.filter(
          (sId) => sId != divisionId
        ))
      : this.selectedDivisions.push(divisionId);
  }

  checkUncheckAllDiv() {
    for (var i = 0; i < this.divisions.length; i++) {
      this.divisions[i].isSelected = this.isDivisionCheck;
    }
    this.getCheckedDivList();
  }

  isAllDivSelected() {
    this.isDivisionCheck = this.divisions.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedDivList();
  }

  getCheckedDivList() {
    this.selectedDivisions = [];
    for (let i = 0; i < this.divisions.length; i++) {
      if (this.divisions[i].isSelected)
        this.selectedDivisions.push(this.divisions[i].id);
    }
  }

  selectDeselectUnits(unitId) {
    this.selectedUnits.includes(unitId)
      ? (this.selectedUnits = this.selectedUnits.filter((sId) => sId != unitId))
      : this.selectedUnits.push(unitId);
  }

  checkUncheckAllUnit() {
    for (var i = 0; i < this.units.length; i++) {
      this.units[i].isSelected = this.isUnitCheck;
    }
    this.getCheckedUnitList();
  }

  isAllUnitSelected() {
    this.isUnitCheck = this.units.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedUnitList();
  }

  getCheckedUnitList() {
    this.selectedUnits = [];
    for (let i = 0; i < this.units.length; i++) {
      if (this.units[i].isSelected) this.selectedUnits.push(this.units[i].id);
    }
  }

  individualContinue() {
    this._course.setIdData({
      ids: this.selectedIndividuals,
      courseCodes: [],
      dueDate: '',
    });
    this._course.setParticipantType({ participantType: 'individuals' });
    this.router.navigate(['/assignCourse/chooseDate']);
  }

  departmentContinue() {
    this._course.setIdData({
      ids: this.selectedDepartments,
      courseCodes: [],
      dueDate: '',
    });
    this._course.setParticipantType({ participantType: 'departments' });
    this.router.navigate(['/assignCourse/chooseDate']);
  }
  divisionContinue() {
    this._course.setIdData({
      ids: this.selectedDivisions,
      courseCodes: [],
      dueDate: '',
    });
    this._course.setParticipantType({ participantType: 'divisions' });
    this.router.navigate(['/assignCourse/chooseDate']);
  }
  unitContinue() {
    this._course.setIdData({
      ids: this.selectedUnits,
      courseCodes: [],
      dueDate: '',
    });
    this._course.setParticipantType({ participantType: 'units' });
    this.router.navigate(['/assignCourse/chooseDate']);
  }
  navigatePage(page) {
    this._staff.getActiveEnterpriseUsers(page, 10).subscribe({
      next: (res) => {
        this.staffs = res['responseResult'].users;
        this.paginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  filter(query: string) {
    this.staffs = query
      ? this.filterStaffs.filter((c) =>
          c.user.fullName.toLowerCase().includes(query.toLowerCase())
        )
      : this.filterStaffs;
  }

  sortbys = (key: string) => {
    this.staffs = key
      ? this.filterStaffs.sort((a, b) => a[key] - b[key])
      : this.filterStaffs;
  };

  filterDepartment(query: string) {
    this.departments = query
      ? this.filterDepartments.filter((d) =>
          d?.name.toLowerCase().includes(query.toLowerCase())
        )
      : this.filterDepartments;
  }

  sortBy(
    category: 'user' | 'departments' | 'divisions' | 'units',
    key: string
  ) {
    if (category === 'user') {
      this.staffs.sort((a, b) => {
        if (a.user[key] < b.user[key]) return -1;
        else if (a.user[key] > b.user[key]) return 1;
        else return 0;
      });
    } else if (category === 'departments') {
      this.departments.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        else if (a[key] > b[key]) return 1;
        else return 0;
      });
    } else if (category === 'divisions') {
      this.divisions.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        else if (a[key] > b[key]) return 1;
        else return 0;
      });
    } else if (category === 'units') {
      this.units.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        else if (a[key] > b[key]) return 1;
        else return 0;
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
